export default __webpack_public_path__ + "static/shared-chapter-0a215ce4460a75af960087fd7d3dc635.svg";